export const authRoutesNames = {
    ROOT: '',
    LOGIN: 'login',
    LOGOUT: 'logout'
};
